import clsx from 'clsx'
import React, { CSSProperties, FC, SVGProps } from 'react'

import styles from './SVGIcon.module.scss'

interface SVGIconProps {
  className?: string
  color?: string
  icon: FC<SVGProps<SVGSVGElement>>
  size?: string
  strokeColor?: string | 'none'
  strokeWidth?: string
}

export const SVGIcon: FC<SVGIconProps> = (
  {
    className,
    color = 'var(--neutral-900)',
    icon: Icon,
    size = '20px',
    strokeColor = 'none',
    strokeWidth = '1px',
  }: SVGIconProps,
) => (
  <div
    aria-hidden
    className={clsx(className, styles.svgIconWrapper)}
    style={{
      '--svgIconWrapperSize': size,
      '--svgIconWrapperColor': color,
      '--svgIconWrapperStrokeColor': strokeColor,
      '--svgIconWrapperStrokeWidth': strokeWidth,
    } as CSSProperties}
  >
    <Icon />
  </div>
)
